import { Card, CardHeader, CardBody, Chip, Skeleton, Tooltip } from "@heroui/react";
import { ThemedText } from "@/components/ui";
import { formatCurrency } from "@/utils";
import { LuInfo } from "react-icons/lu";

const SkeletonRow = () => (
    <div className="flex items-center justify-between py-2">
        <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-24 rounded-md" />
            <Skeleton className="h-4 w-12 rounded-full" />
        </div>
        <Skeleton className="h-4 w-28 rounded-md" />
    </div>
);

const CashBalancesCard = ({ balances, isLoading }) => {
    const totalBalance =
        balances?.reduce((sum, item) => sum + item.balance, 0) ?? 0;

    return (
        <Card className="border-default-200 border" shadow="none">
            <CardHeader className="flex flex-row items-center justify-between px-4 pt-4 pb-0">
                <div className="flex items-center gap-1.5">
                    <Tooltip
                        content="Ringkasan saldo per akun kas (pemasukan - pengeluaran)"
                        placement="right"
                    >
                        <span className="cursor-help text-default-400">
                            <LuInfo size={12} />
                        </span>
                    </Tooltip>
                    <ThemedText size="md" className="font-semibold">
                        Saldo Kas
                    </ThemedText>
                </div>
                {!isLoading && (
                    <div className="flex items-center gap-2">
                        <ThemedText variant="secondary" size="xs">
                            Total:
                        </ThemedText>
                        <ThemedText
                            size="sm"
                            className="font-bold"
                            variant={totalBalance >= 0 ? "success" : "danger"}
                        >
                            {formatCurrency(totalBalance)}
                        </ThemedText>
                    </div>
                )}
            </CardHeader>
            <CardBody className="px-4 pt-2 pb-4">
                <div className="grid grid-cols-1 gap-x-8 gap-y-1 sm:grid-cols-2">
                    {isLoading ? (
                        Array.from({ length: 4 }).map((_, i) => (
                            <SkeletonRow key={i} />
                        ))
                    ) : balances?.length > 0 ? (
                        balances.map((item) => (
                            <div
                                key={item.id}
                                className="flex items-center justify-between py-2"
                            >
                                <div className="flex items-center gap-3">
                                    <div
                                        className={`h-1.5 w-1.5 shrink-0 rounded-full ${
                                            item.balance >= 0
                                                ? "bg-success-500"
                                                : "bg-danger-500"
                                        }`}
                                    />
                                    <div className="flex flex-col">
                                        <ThemedText
                                            size="sm"
                                            className="font-medium"
                                        >
                                            {item.name}
                                        </ThemedText>
                                        <ThemedText
                                            variant="secondary"
                                            size="xxs"
                                        >
                                            {item.category}
                                        </ThemedText>
                                    </div>
                                </div>
                                <ThemedText
                                    size="sm"
                                    className="font-medium tabular-nums"
                                    variant={
                                        item.balance >= 0 ? "success" : "danger"
                                    }
                                >
                                    {formatCurrency(item.balance)}
                                </ThemedText>
                            </div>
                        ))
                    ) : (
                        <div className="col-span-full py-8 text-center">
                            <ThemedText variant="secondary" size="sm">
                                Belum ada data kas.
                            </ThemedText>
                        </div>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default CashBalancesCard;
